import React from 'react';
import styled from 'styled-components'

export const Foot = styled.footer`
display: flex;
justify-content: space-between;
padding-left: 15em;
padding-right: 15em;
background-color: #202027;
margin-top: 7.7em;
`
export const Div = styled.div`
background-color: #202027;
display: flex;
gap: 2em;
line-height: 3;
`
export const Link = styled.p`
background-color: #202027;


`